import React from "react";

/**
 * BulkActionBar Component
 * 
 * Displays a floating action bar at the bottom right of the screen when items are selected.
 * Shows the count of selected items and provides actions to delete or cancel selection.
 * 
 * @param {Object} props - Component props
 * @param {number} props.selectedCount - Number of items selected
 * @param {Function} props.onDelete - Handler for delete action
 * @param {Function} props.onCancel - Handler for cancel action
 * @param {string} props.itemType - Type of items being selected (e.g., "category", "subcategory", "service")
 * @returns {JSX.Element|null} The bulk action bar component or null if no items selected
 */
const BulkActionBar = ({ selectedCount, onDelete, onCancel, itemType = "item" }) => {
  if (selectedCount === 0) return null;
  
  return (
    <div className="fixed bottom-4 right-4 bg-white shadow-lg rounded-lg p-4 border border-gray-200 z-50">
      <div className="flex items-center space-x-4">
        <span className="text-sm font-medium text-gray-700">
          {selectedCount} {itemType}{selectedCount > 1 ? 's' : ''} selected
        </span>
        <button
          onClick={onCancel}
          className="px-3 py-1 text-sm text-gray-600 hover:text-gray-800 transition-colors"
        >
          Cancel
        </button>
        <button
          onClick={onDelete}
          className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 flex items-center space-x-2 transition-colors"
        >
          <svg
            className="w-4 h-4"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
            />
          </svg>
          <span>Delete Selected</span>
        </button>
      </div>
    </div>
  );
};

export default BulkActionBar;
